import "./m00-missing-block.styles.scss";
import * as React from "react";

interface IMissingBlockProps {
    kind: string;
}

export const M00MissingBlock: React.FC<IMissingBlockProps> = React.memo(({ kind }: IMissingBlockProps): JSX.Element => (
    <div className="missing-block" dangerouslySetInnerHTML={{ __html: `<!-- Missing block: ${kind} -->` }} />
));
